module.exports = __webpack_public_path__ + "static/media/needle.4189f677.svg";